import styled from "styled-components";
import { colors } from "../../util/constants";

const NewInput = styled.input`
  height: 42px !important;
  width: 100% !important;
  border: 1px solid ${props => (props.error ? colors.error : "#dfdfdf")} !important;
  background-color: #ffffff !important;
  border-radius: 3px !important;
  font-size: 16px !important;
  color: #484848 !important;
  outline: none !important;
  text-indent: ${props => (props.indent ? props.indent : "10px")} !important;
  ${props => (props.leftIcon ? "text-indent: 28px !important" : "")};
  padding: 0 !important;
  margin: 0 !important;
  ${props =>
    props.margin ? "margin:" + props.margin + " !important" : "0 !important"};
  font-family: "Roboto", sans-serif !important;
  transition: border 0.3s ease-in-out !important;

  background-image: ${props =>
    props.leftIcon ? `url(${props.leftIcon})` : ""} !important;

  background-size: 15px 15px !important;
  background-repeat: no-repeat !important;
  background-position: 8px center !important;

  &:focus {
    border-color: #a0a0a0 !important;
  }

  &:disabled {
    border-color: #efefef !important;
  }

  &:placeholder {
    opacity: 1 !important;
    font-size: 16px !important;
    color: #a0a0a0 !important;
    font-weight: 300 !important;
  }
  &::-webkit-input-placeholder {
    /* Chrome */
    opacity: 1 !important;
    font-size: 16px !important;
    color: #a0a0a0 !important;
    font-weight: 300 !important;
    transition: opacity 0.3s ease-in-out !important;
  }
  &:focus::-webkit-input-placeholder {
    opacity: 0.5 !important;
  }
  &:-ms-input-placeholder {
    /* IE 10+ */
    opacity: 1 !important;
    font-size: 16px !important;
    color: #a0a0a0 !important;
    font-weight: 300 !important;
    transition: opacity 0.3s ease-in-out !important;
  }
  &:focus:-ms-input-placeholder {
    opacity: 0.5 !important;
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    opacity: 1 !important;
    font-size: 16px !important;
    color: #a0a0a0 !important;
    font-weight: 300 !important;
    transition: opacity 0.3s ease-in-out !important;
  }
  &:focus::-moz-placeholder {
    opacity: 0.5 !important;
  }
  &:-moz-placeholder {
    /* Firefox 4 - 18 */
    opacity: 1 !important;
    font-size: 16px !important;
    color: #a0a0a0 !important;
    font-weight: 300 !important;
    transition: opacity 0.3s ease-in-out !important;
  }
  &:focus:-moz-placeholder {
    opacity: 0.5 !important;
  }
  &:disabled::-webkit-input-placeholder {
    color: #dfdfdf !important;
  }
  &:disabled:-ms-input-placeholder {
    color: #dfdfdf !important;
  }
  &:disabled::-moz-placeholder {
    color: #dfdfdf !important;
  }
  &:disabled:-moz-placeholder {
    color: #dfdfdf !important;
  }

  &:disabled:placeholder {
    color: #dfdfdf !important;
  }
  &:required {
    box-shadow: none !important;
  }
`;

export default NewInput;



// WEBPACK FOOTER //
// ./src/components/FormComponents/NewInput.jsx